export default __webpack_public_path__ + "static/media/transaction-complete-icon.54030082.svg";